import api from "@/services/api";
import { ENDPOINTS } from "@/constants/endpoints";
import url from "@/helpers/url";

export default {
  async apiv4UserBySession() {
    try {
      const { data } = await api.get(url(ENDPOINTS.apiv4UserBySession, {}));
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async apiv4Session() {
    try {
      const { data } = await api.get(url(ENDPOINTS.apiv4Session, {}));
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async recoverPassword(email) {
    try {
      const { data } = await api.post(ENDPOINTS.recoverPassword, {
        email,
      });
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async recoverPasswordRegCode(regCode) {
    try {
      const { data } = await api.post(ENDPOINTS.recoverPassword, {
        regCode,
      });
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async resetPassword(
    email,
    type = "email",
    token,
    newPassword,
    confirmPassword
  ) {
    try {
      const { data } = await api.post(
        `${ENDPOINTS.resetPassword}?${type}=${email}&token=${token}`,
        {
          newPassword,
          confirmPassword,
        }
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async changeRole(role) {
    return await api.put(ENDPOINTS.change_role, { new_role: role });
  },
  async changeRepresentation(user_id, role_id) {
    return await api.patch(ENDPOINTS.change_representation, {
      user_id: user_id,
      role_id: role_id,
    });
  },
  async fetchUser() {
    return await api.get(ENDPOINTS.user);
  },
  async changeLang(lang) {
    return await api.put(ENDPOINTS.language, { language: lang });
  },
  async authSmartId(personCode) {
    if (!personCode) {
      return Promise.reject("person code is required!");
    }
    return await api.post(ENDPOINTS.login_smartid, { personCode });
  },
  async validateSmartId(data) {
    return await api.get(ENDPOINTS.validate_smartid, { params: { ...data } });
  },

  async authMobileId(IDCode, PhoneNo) {
    if (!IDCode || !PhoneNo) {
      return Promise.reject("IDCode and PhoneNo are required!");
    }
    return await api.post(ENDPOINTS.login_mobileid, { IDCode, PhoneNo });
  },
  async validateMobileId(data) {
    return await api.get(ENDPOINTS.login_mobileid, { params: { ...data } });
  },
  async getUserProfile() {
    return await api.get(ENDPOINTS.profile);
  },
  async getUserApartment() {
    return await api.get(ENDPOINTS.profileApartments);
  },
  async patchUserProfile(body) {
    return await api.patch(ENDPOINTS.profile, body);
  },
  async patchUserPassword(body) {
    return await api.patch(ENDPOINTS.profilePassword, body);
  },
  async patchOnBoarding() {
    return await api.patch(ENDPOINTS.onBoarding);
  },
  async getOnBoarding() {
    return await api.get(ENDPOINTS.onBoarding);
  },
  async getUserCooperatives(roleId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.userCooperatives, { roleId })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async updateUserRole(id, body) {
    try {
      const { data } = await api.patch(
        url(ENDPOINTS.updateUserRole, { id }),
        body
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async deleteUserRole(id) {
    try {
      const { data } = await api.delete(url(ENDPOINTS.userRole, { id }));
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
